import React from "react";
import { Input } from "components/ui/input";
import { ClientUserIcon } from "components/Icons";
import ProfileDefaultImage from "assets/icons/default_avater.svg";
import { CameraIcon } from "components/Icons";
import UploadModal from "components/Modal/UploadImage/UploadImageModal";
import { useFormContext } from "react-hook-form";

export const ProfileHeader = ({ user, imageResult, onUploadClick }) => {
  const formContext = useFormContext();

  const {
    register,
    formState: { errors },
  } = formContext;

  return (
    <div className="flex flex-col md:flex md:flex-row items-center gap-[20px]">
      <div className="flex w-full justify-center md:w-auto">
        <div className="relative">
          <img
            src={imageResult ? imageResult : user?.photo || ProfileDefaultImage}
            alt="profile"
            className="profile-pic flex w-[85px] h-[85px] rounded-full"
          />
          <div
            onClick={onUploadClick}
            className="camera-icon z-10 flex items-center justify-center cursor-pointer absolute w-[42px] h-[42px] rounded-full bg-[#5C80B6] hover:bg-gray-500 hover:bg-opacity-95 hover:animate-pulse mb-[-10px] bottom-0 left-12"
          >
            <CameraIcon className="!text-transparent" />
          </div>
          <UploadModal />
        </div>
      </div>

      <div className="w-full md:w-auto">
        <Input
          name="firstName"
          className="w-full md:w-[250px] md:top-[20px]"
          icon={<ClientUserIcon className="!text-transparent" />}
          label="First Name"
          placeholder="Enter your First Name here"
          {...register("firstName")}
          required
        />
        <div className="h-2">
          {errors.firstName && (
            <p className="text-red-500 text-sm font-montserrat mt-1">
              {errors.firstName?.message}
            </p>
          )}
        </div>
      </div>

      <div className="w-full md:w-auto">
        <Input
          type="text"
          name="lastName"
          className="w-full md:w-[250px] md:top-[20px]"
          icon={<ClientUserIcon className="!text-transparent" />}
          label="Last Name"
          placeholder="Enter your Last Name here"
          {...register("lastName")}
          required
        />
        <div className="h-2">
          {errors.lastName && (
            <p className="text-red-500 text-sm font-montserrat mt-1">
              {errors.lastName?.message}
            </p>
          )}
        </div>
      </div>

    </div>
  );
};
